import { useEffect, useState } from "react";
import useDataBean from "../../../../core/services/dataBean/useDataBean";
import usePaginator from "../../../theme/Component/usePaginator";
import { _CreditStructure, _single } from "../../../../core/services/dataBean/EntityCatalog";
import { toast } from "react-toastify";
import { BasicPage } from "../../../theme/Component/BasicPage";
import { AccountEditor } from "../../../editor/AccountEditor";
import { BasicButton } from "../../../theme/Component/BasicButton";
import { CreditAccountEditor } from "../../../custom/forpo/components/Credit/CreditAccountEditor";
import useModal, { MODAL_LG, MODAL_SM } from "../../../theme/Component/hooks/useModal";
import { SelectCreditStructureConstants } from "./Components/SelectCreditStructureConstants";
import { Modal } from "../../../theme/Component/Modal";
import { PrintJson } from "../../../theme/Component/PrintJson";
import { BasicTable, MASK_MONEY, MASK_NUMBER } from "../../../theme/Component/BasicTable";
import { SimulatorAmountSelector } from "../../../bpm/CustomFormNew/CustomForms/CreditoyCartera/Components/SimulatorAmountSelector";
import { InputMoney } from "../../../theme/Input/InputMoney";
import { _LoanLine } from "../../../../core/services/dataBean/EntityCatalogVdos";
import { AccountCreditSimulator } from "../../../Talentohumano/GestionTH/EmployeeContract/CreditAccount/AccountCreditSimulator/AccountCreditSimulator";

interface DataForm {
  IdAccount: number;
  Credit: Record<string, any>;
  typeChange: number
}

export const EstructuredCredit = () => {
  const { instance, bean, setBean, lista, setLista } = useDataBean(_CreditStructure);
  const { bean: dataLoan, setBean: setDataLoan, instance: serviceLoan } = useDataBean(_LoanLine);
  const paginador = usePaginator();

  const modal = useModal(`Estructuración de Credito`, MODAL_LG);
  const modalSimulator = useModal(`Simulador`, MODAL_LG);

  const [filters, setFilters] = useState<Partial<DataForm>>({});
  const [obs, setObs] = useState<string>("");
  const [range, setRange] = useState<any[]>([]);

  useEffect(() => {
    if (filters.Credit?.IDCreditAccount) getLista();
  }, [filters.Credit?.IDCreditAccount]);

  useEffect(() => {
    if (filters.Credit?.IDLoanLine) getLoanLine(filters.Credit?.IDLoanLine);
  }, [filters.Credit?.IDLoanLine]);


  const getLoanLine = (id: number) => {
    serviceLoan.getLoanLine(id).then(
      (resp) => {
        setDataLoan(resp)
        if (resp.QuotaRange != "") {
          setRange(resp.QuotaRange.split(",").map(Number));
        }
      }
    ).catch(
      err => { toast.error("Error al cargar la linea de credito") }
    )
  }

  const getLista = () => {
    const props = {
      IDCreditAccount: filters.Credit?.IDCreditAccount,
      State: 1
    }
    instance.getCreditStructureRender(paginador.page, 15, props).then(
      (resp) => {
        setLista(resp);
      }
    ).catch(err => { toast.error(err) });
  }

  const renderForm = (changeType: number) => {
    switch (changeType) {
      case 100: //modificacion cuota
        return (
          <div className="row mt-3">
            <div className="col-md-6 d-flex">
              <strong>Capital:</strong>
              <div dangerouslySetInnerHTML={{ __html: _single.formatFieldMask(bean.PagoCapital, MASK_MONEY) }}></div>
            </div>
            <div className="col-md-6 d-flex">
              <strong>Interes:</strong>
              <div dangerouslySetInnerHTML={{ __html: _single.formatFieldMask(bean.PagoInteresCorriente, MASK_MONEY) }}></div>
            </div>
            <div className="col-md-12">
              <InputMoney _value={bean.CuoteAmount} onChange={(e) => { setBean({ ...bean, CuoteAmount: e }) }} _label="Valor de la Cuota" />
            </div>
          </div>
        );
      case 101: //modificacion tasa
        return (
          <div className="row">
            <div className="col-md-12">
              <label>Tasa de Interes</label>
              <input type="number" className="form-control" value={bean.RateValueCredit} onChange={(e) => {
                const valor = e.target.value ? parseFloat(e.target.value) : 0;
                setBean({ ...bean, RateValueCredit: valor })
              }} />
            </div>
          </div>
        );
      case 102: //modificacion plazo
        return (
          <div className="row">
            <div className="col-md-12">
              <label>Plazos disponibles</label>
              <select className="form-select" value={bean.Cuotes} onChange={(e) => { setBean({ ...bean, Cuotes: Number(e.target.value) }) }} >
                {range.map((dato, index) => {
                  return (
                    <option key={index} value={dato}>{dato}</option>
                  );
                })}
              </select>
            </div>
          </div>
        );
      case 103: //suspension cuota
        return (
          <>suspension cuota</>
        );
      case 104: //suspension fallecimiento
        return (
          <>
            suspension fallecimiento
          </>
        );

      default:
        break;
    }
  }

  const renderName = (changeType: number) => {
    switch (changeType) {
      case 100:
        return "Modificación Cuota";
      case 101:
        return "Modificación Tasa";
      case 102:
        return "Modificación Plazo";
      case 103:
        return "Suspencion Cuota";
      case 104:
        return "Suspencion Fallecimiento";

      default:
        break;
    }
  }

  const updateCredit = () => {
    instance.createCreditStructure(_single.getAccountID(), filters.typeChange, bean, obs).then(
      (resp) => {
        setObs("");
        modal.close();
        setFilters({ ...filters, typeChange: null });
      }
    ).catch(
      err => { toast.error(err) }
    )
  }

  const head = [
    { title: 'ID', property: 'IDCreditStructure', visible: false, mask: MASK_NUMBER },
    { title: 'Fecha', property: 'Since', visible: true },
    { title: 'Observaciones', property: 'Observation', visible: true },
  ]


  return (
    <BasicPage titulo="Estructuración Créditos Tercero">
      <div className="row">
        <div className="col-md-4">
          <AccountEditor
            idAccount={filters.IdAccount}
            label="Tercero"
            onChange={(e) =>
              setFilters((prev) => ({ ...prev, IdAccount: e.IDAccount, }))
            }
          />
        </div>
        {filters.IdAccount &&
          <div className="col-md-4">
            <CreditAccountEditor idAccount={filters.IdAccount} onChange={(e) => { setFilters((prev) => ({ ...prev, Credit: e })); setBean(e) }} label="Crédito Seleccionado" />
          </div>
        }
        {filters.Credit?.IDCreditAccount &&
          <div className="col-md-4">
            <SelectCreditStructureConstants idSelector={filters.typeChange} onChange={(e) => { setFilters((prev) => ({ ...prev, typeChange: e })) }} label="Tipo de Estructuración" />
          </div>
        }
        <div className="col-md-3">
          <BasicButton
            eventClick={() => {
              modal.open(`Estructuración de Credito - ${renderName(filters.typeChange)}`);
            }}
            disable={!filters.IdAccount || !filters.Credit?.IDCreditAccount || !filters.typeChange}
            useMargin
            icon="ri-send-plane-line"
          >
            Estructurar
          </BasicButton>
        </div>

        {lista.length > 0 &&
          <div className="col-md-12">
            <BasicTable body={lista} head={head} rowSet={() => { }} />
          </div>
        }

        <div className="col">
          <Modal modal={modal.modal} updateModal={modal.setModal} eventModal={() => { updateCredit() }}>
            <div className="row">
              <div className="col-md-4">
                <BasicButton icon="ri-money-dollar-circle-line" eventClick={() => { modalSimulator.open() }} children={"Simulador"} />
              </div>
              <div className="col-md-12">
                {renderForm(filters.typeChange)}
              </div>
              <div className="col-md-12">
                <label>Observaciones</label>
                <textarea className="form-control" value={obs} onChange={(e) => { setObs(e.target.value) }}></textarea>
              </div>
            </div>
          </Modal>

          <Modal modal={modalSimulator.modal} updateModal={modalSimulator.setModal}>
            <div className="row">
              <div className="col-md-12">
                <AccountCreditSimulator componentForma="Component" initialCredit={{
                  CreditQuotes: bean.Cuotes,
                  CreditValue: bean.AmountCredit,
                  CurrentPercentInterest: bean.RateValueCredit,
                  IDLoanLine: bean.IDLoanLine,
                }} />
              </div>
            </div>
          </Modal>
        </div>
      </div>
    </BasicPage>
  );
};
